const translations = {
  en: {
    depositUsing: 'Deposit using',
    currency: 'Currency',
    amount: 'Amount',
    depositLimits: 'Deposit Limits: Minimum',
    maximum: 'Maximum',
    noLimit: 'No Limit',
    transactionID: 'TransactionID:',
    send: 'Send',
    toThisAddress: 'to this address:',
    toThisInvoice: 'to this INVOICE:',
    onlyNetworkWarning: 'Only {network} can be sent to the generated address from the selected network.  Deposits of other crypto currencies or networks will be lost.',
    back: 'BACK',
    deposit: 'DEPOSIT',
    requestNewAddress: 'Request new address',
    depositStatus: 'Deposit Status',
    yourTransactionWas: 'Your Transaction was',
    warning: 'Warning',
    error: 'Error',
    amountRequired: 'Amount required',
  },
  es: {
    depositUsing: 'Depositar usando',
    currency: 'Moneda',
    amount: 'Monto',
    depositLimits: 'Límites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sin Límite',
    transactionID: 'ID de Transacción:',
    send: 'Enviar',
    toThisAddress: 'a esta dirección:',
    toThisInvoice: 'a este INVOICE:',
    onlyNetworkWarning: 'Solo {network} puede ser enviado a la dirección generada desde la red seleccionada. Los depósitos de otras criptomonedas o redes se perderán.',
    back: 'ATRÁS',
    deposit: 'DEPOSITAR',
    requestNewAddress: 'Solicitar nueva dirección',
    depositStatus: 'Estado del Depósito',
    yourTransactionWas: 'Su transacción fue',
    warning: 'Advertencia',
    error: 'Error',
    amountRequired: 'Monto requerido',
  },
  pt: {
    depositUsing: 'Depositar usando',
    currency: 'Moeda',
    amount: 'Valor',
    depositLimits: 'Limites de depósito: Mínimo',
    maximum: 'Máximo',
    noLimit: 'Sem Limite',
    transactionID: 'ID da Transação:',
    send: 'Enviar',
    toThisAddress: 'para este endereço:',
    toThisInvoice: 'para este INVOICE:',
    onlyNetworkWarning: 'Somente {network} pode ser enviado ao endereço gerado da rede selecionada. Depósitos de outras criptomoedas ou redes serão perdidos.',
    back: 'VOLTAR',
    deposit: 'DEPOSITAR',
    requestNewAddress: 'Solicitar novo endereço',
    depositStatus: 'Status do Depósito',
    yourTransactionWas: 'Sua transação foi',
    warning: 'Aviso',
    error: 'Erro',
    amountRequired: 'Valor obrigatório',
  },
}

export default translations
